import * as tslib_1 from "tslib";
import { WorkflowBaseDroppedField } from '../base-dropped-field.component';
var WorkflowDroppableSignDateFieldComponent = /** @class */ (function (_super) {
    tslib_1.__extends(WorkflowDroppableSignDateFieldComponent, _super);
    function WorkflowDroppableSignDateFieldComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.date = Date.now();
        return _this;
    }
    return WorkflowDroppableSignDateFieldComponent;
}(WorkflowBaseDroppedField));
export { WorkflowDroppableSignDateFieldComponent };
